<template>
  <div class="relative" id="pic">
    <img
      class="w-screen h-screen object-cover absolute left-0 top-0 hidden"
      style="filter: blur(60) brightness(60%); z-index: -30"
      :src="require('@/assets/img/image1.png')"
    />
    <img
      class="w-full h-full object-cover absolute left-0 top-0"
      style="z-index: -20"
      :src="require('@/assets/img/image1.png')"
    />
    <div
      class="bg-gray-800 w-full h-full absolute left-0 top-0 anim"
      style="z-index: -10"
      :class="step >= 1 ? 'opacity-50' : 'opacity-0'"
    ></div>
    <div class="w-full h-full">
      <div class="w-10 h-10 absolute top-6 left-6 text-white">{{ step }}</div>
      <img
        class="w-10 h-10 absolute top-6 right-6 swiper-button-next"
        :class="last_page ? 'hidden' : ''"
        style="z-index: 20"
        :src="
          musiccontrol
            ? require('@/assets/img/music.png')
            : require('@/assets/img/music_off.png')
        "
        @click="close"
      />

      <div class="audio">
        <!--隐藏audio标签-->
        <audio ref="music1" id="music1">
          <source :src="bg_music" />
        </audio>
      </div>

      <!--                    1                     -->
      <div
        class="flex h-full w-full mx-auto anim transform"
        :class="step >= 2 && step <= 6 ? 'opacity-100' : 'opacity-0 '"
        v-if="step >= 1 && step <= 7"
      >
        <div class="m-auto">
          <p
            class="text-center text-white text-3xl anim transform"
            v-if="step >= 2 && step < 4"
            :class="step >= 2 ? '' : 'opacity-0 h-0 translate-y-20'"
          >
            從美食看性格?
          </p>
          <p
            class="text-center text-white text-3xl anim transform"
            :class="step >= 4 ? '' : 'opacity-0 h-0 translate-y-20'"
          >
            從美食看性格?
          </p>

          <p
            v-if="step >= 2 && step < 4"
            class="text-center text-white text-2xl anim transform"
            :class="step >= 2 ? '' : 'opacity-0 h-0 translate-y-20'"
          >
            來看看你的專屬動物吧！
          </p>
          <p
            class="text-center text-white text-2xl anim transform"
            :class="step >= 4 ? '' : 'opacity-0 h-0 translate-y-20'"
          >
            來看看你的專屬動物吧！
          </p>
          <img
            class="my-16 mx-auto anim transform"
            :class="step >= 4 ? '' : 'opacity-0 h-0 translate-y-20'"
            :src="require('@/assets/img/logo.png')"
          />
          <p
            class="text-center text-white text-xl anim transform"
            :class="step >= 4 ? '' : 'opacity-0 h-0  translate-y-20'"
          >
            這是一款由「吃什麼」<br />App結合食物心理學<br />從你愛的食物看出你隱藏的真實性格
          </p>
          <div class="h-16 w-full mt-20" v-if="step >= 4 && step <= 8">
            <button
              class="
                bg-cusblue
                text-white
                h-14
                w-full
                rounded-full
                text-3xl
                anim
                audio
                transform
              "
              :class="step >= 6 ? 'opacity-100' : 'opacity-0  '"
              v-if="step >= 6 && step <= 7"
              @click="start_button()"
            >
              開始
            </button>
            <p
              class="text-center text-cusrice text-xl anim mt-5 transform"
              :class="step >= 6 ? 'opacity-100' : 'opacity-0 '"
            >
              右上角可以設定音樂喲!!!
            </p>
          </div>
        </div>
      </div>

      <!--                    2                     -->
      <div
        class="flex h-full w-5/6 mx-auto anim transform"
        :class="
          step == 12 ||
          step == 21 ||
          step == 23 ||
          step == 25 ||
          step == 27 ||
          step == 29
            ? 'opacity-100'
            : 'opacity-0 -translate-x-10'
        "
        v-if="
          (step >= 11 && step <= 13) ||
          (step >= 20 && step <= 22) ||
          (step >= 22 && step <= 24) ||
          (step >= 24 && step <= 26) ||
          (step >= 26 && step <= 28) ||
          (step >= 28 && step <= 30)
        "
      >
        <div class="relative m-auto">
          <img class="mx-auto" :src="require('@/assets/img/book.png')" />
          <div
            class="w-5/6 mb-4 absolute left-1/2 transform -translate-x-1/2"
            style="top: 20%"
            v-if="
              step == 12 ||
              step == 21 ||
              step == 23 ||
              step == 25 ||
              step == 27 ||
              step == 29
            "
          >
            <p class="text-left text-xl text-cusbrown3">
              {{ questions[questionIndex].title }}
            </p>
            <div class="grid grid-cols-2 gap-5 mt-3">
              <audio id="music3">
                <source src="@/assets/music/turn_pages.mp3" />
              </audio>
              <div
                :class="
                  animal[animal.length - 1] == i
                    ? 'bg-cusans_blue'
                    : 'bg-cuswhite'
                "
                class="
                  rounded-lg
                  border border-solid border-cusbrown3
                  h-20
                  flex
                  text-base
                  cursor-pointer
                  justify-center
                  items-center
                  anim
                "
                v-for="i in questions[questionIndex].awns"
                :key="i"
                @click="choice(i), start_music('music3', 2500)"
              >
                <p class="text-cusbrown2 text-center text-sm m-3">
                  {{ i }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--                    3                     -->
      <div
        class="flex h-full w-5/6 mx-auto anim transform"
        :class="
          step >= 14 && step <= 18
            ? 'opacity-100'
            : 'opacity-0 h-0  translate-y-10'
        "
        v-if="step >= 13 && step <= 19"
      >
        <div class="relative m-auto w-full">
          <div class="">
            <p
              class="text-center text-lg text-white anim transform"
              v-if="step >= 14 && step < 17"
              :class="step >= 14 ? '' : 'opacity-0 h-0 translate-y-20'"
            >
              2.周末很快就到了
            </p>
            <p
              class="text-center text-lg text-white anim transform"
              :class="step >= 17 ? '' : 'opacity-0 h-0 translate-y-24'"
            >
              2.周末很快就到了
            </p>
            <p
              class="text-center text-lg text-white anim transform"
              v-if="step >= 14 && step < 17"
              :class="step >= 15 ? '' : 'opacity-0 h-0 translate-y-20'"
            >
              你們從「吃什麼」App
            </p>
            <p
              class="text-center text-lg text-white anim transform"
              :class="step >= 17 ? '' : 'opacity-0 h-0 translate-y-24'"
            >
              你們從「吃什麼」App
            </p>
            <p
              class="text-center text-lg text-white anim transform"
              v-if="step >= 14 && step < 17"
              :class="step >= 16 ? '' : 'opacity-0 h-0 translate-y-20'"
            >
              找到了大家都想吃的餐廳
            </p>
            <p
              class="text-center text-lg text-white anim transform"
              :class="step >= 17 ? '' : 'opacity-0 h-0 translate-y-24'"
            >
              找到了大家都想吃的餐廳
            </p>
          </div>
          <div class="h-124 w-5/6 mx-auto" v-if="step >= 17 && step <= 19">
            <img
              v-show="reloadGif"
              class="my-2 mx-auto anim transform w-5/6"
              :class="step >= 17 ? '' : 'opacity-0 h-0 translate-y-20'"
              :src="!reloadGif || waht_eat_gif"
            />

            <button
              class="
                bg-cusblue
                text-white
                mt-1
                h-10
                w-full
                rounded-full
                text-lg
                anim
                transform
              "
              :class="step >= 18 ? 'opacity-100' : 'opacity-0 '"
              v-if="step >= 18 && step <= 19"
              @click="
                wait_step18(2400);
                start_music('music2', 2500);
                change_bg_music(require('@/assets/music/enter_restaurant.mp3'));
              "
            >
              <audio id="music2">
                <source src="@/assets/music/step.mp3" />
              </audio>
              點擊進入下一個畫面
            </button>
          </div>
        </div>
      </div>

      <!--                    4                     -->
      <div
        class="flex h-full w-5/6 mx-auto anim transform"
        :class="
          step == 31 || step == 32 ? 'opacity-100' : 'opacity-0 -translate-x-10'
        "
        v-if="step >= 30 && step <= 33"
      >
        <div class="relative m-auto w-full">
          <div class="">
            <p
              class="text-left text-2xl text-white anim"
              :class="step >= 31 ? 'opacity-100' : 'opacity-0'"
            >
              8. 愉快地吃完飯了, 你來到櫃檯準備結帳。
            </p>
          </div>
          <div
            class="relative w-full anim"
            :class="step >= 32 ? 'opacity-100' : 'opacity-0'"
          >
            <img
              class="my-8 mx-auto"
              :src="require('@/assets/img/book2.png')"
            />
            <div
              class="absolute left-1/2 transform -translate-x-1/2"
              style="top: 20%"
              v-if="step >= 32 && step <= 33"
            >
              <p class="text-center text-2xl text-cusbrown3">簽名結帳</p>
              <div class="flex">
                <input
                  type="text"
                  ref="getValue"
                  class="
                    text-xl
                    mt-8
                    h-14
                    rounded-xl
                    border border-solid border-cusbrown3
                    text-center
                  "
                />
              </div>
              <button
                class="
                  bg-cusblue
                  text-white
                  h-12
                  w-full
                  rounded-full
                  mt-14
                  text-base
                  cursor-pointer
                  audio
                "
                @click="change_word(), get_name()"
              >
                分析我是什麼美食性格動物

                <audio id="music4">
                  <source src="@/assets/music/bill.mp3" />
                </audio>
              </button>

              <img
                class="w-5/6 my-6 mx-auto"
                :src="require('@/assets/img/bill_logo.png')"
              />
            </div>
          </div>
        </div>
      </div>

      <!--                    5                     -->
      <div
        class="flex h-full w-5/6 mx-auto anim transform"
        :class="
          step >= 40 && step <= 41 ? 'opacity-100' : 'opacity-0 -translate-x-10'
        "
        v-if="step >= 39 && step <= 42"
      >
        <div class="relative m-auto">
          <div
            class="absolute left-1/2 transform -translate-x-1/2"
            :style="analyze_word === '分析結束' ? 'top: 6.5%' : 'top: 3.5%'"
            style="height: 8%"
          >
            <p
              class="text-center text-white text-base"
              v-html="analyze_word"
            ></p>
          </div>
          <img clas s=" mx-auto" :src="require('@/assets/img/book.png')" />
          <div
            class="w-5/6 mb-6 absolute left-1/2 transform -translate-x-1/2"
            style="top: 15%"
          >
            <p class="text-left text-sm text-cusbrown3 mt-4">
              這是「吃什麼」APP 推出的心理測驗<br /><br />
              你是不是常常不知道要吃什麼?<br />
              「吃什麼」是一款擁有全台灣美食餐廳的APP，透過地區搜尋與用戶評價快速找到符合您的餐廳。<br /><br />
              想了解更多嗎？<br /><br />
              快去下載「吃什麼」APP 吧！
            </p>
            <div class="flex">
              <button
                class="
                  bg-cusblue
                  text-white
                  h-10
                  w-5/6
                  rounded-full
                  mt-8
                  text-lg
                  mx-auto
                  cursor-pointer
                  anim
                "
                :class="step >= 41 ? '' : 'opacity-0 h-0'"
                v-if="step >= 41 && step <= 42"
                @click="
                  run_love_41(),
                    change_bg_music(require('@/assets/music/ending_music.mp3')),
                    (last_page = true)
                "
              >
                看看我隱藏的動物性格
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--                    6                     -->
      <div
        class="flex h-full w-5/6 mx-auto anim transform"
        :class="step >= 44 && step <= 46 ? 'opacity-100 ' : 'opacity-0 '"
        v-if="step >= 43 && step <= 47"
      >
        <div
          class="w-full relative left-1/2 transform -translate-x-1/2"
          style="height: 25vh; top: 32%"
        >
          <img
            class="m-auto w-1/3 anim transform"
            :style="
              step >= 44 && step <= 46
                ? 'transform:scale(1.2)'
                : 'transform:scale(10)'
            "
            v-if="step >= 43 && step <= 47"
            style="height: 13vh"
            :src="require('@/assets/img/love.png')"
          />
          <img
            class="m-auto w-2/3 anim transform mt-4"
            v-if="step >= 43 && step <= 46"
            :src="require('@/assets/img/what_eat_logo.png')"
          />
        </div>
      </div>
      <!--                    7                     -->
      <div
        class="flex h-full w-full mx-auto anim transform"
        :class="step == 51 ? 'opacity-100' : 'opacity-0 '"
        v-if="step >= 50 && step <= 52"
      >
        <img
          class="w-10 h-10 absolute top-8 left-8 cursor-pointer"
          :src="require('@/assets/img/back.png')"
          v-if="img_hidden === false"
          @click="
            step++;
            reset();
          "
        />
        <a
          target="_blank"
          v-if="step >= 51 && step <= 52 && img_hidden === false"
          class="
            w-20
            h-10
            absolute
            top-8
            right-4
            text-cusrice text-lg
            cursor-pointer
          "
          href="https://www.whatseat.com.tw/"
        >
          官方網站
        </a>
        <div
          class="absolute left-1/2 transform -translate-x-1/2"
          style="height: 12vh; top: 4%"
          v-if="step >= 51 && step <= 52"
        >
          <img class="h-full" :src="resultImageIcon" />
        </div>
        <div
          class="w-5/6 absolute left-1/2 transform -translate-x-1/2"
          style="height: 60vh; top: 12%"
          v-if="step >= 51 && step <= 52"
        >
          <div class="relative">
            <img class="mx-auto ml-3" :src="resultImage" />
            <div
              class="absolute left-0 bottom-0 cursor-pointer"
              style="width: 40%; height: 12%"
              id="test"
              @click="getImg_hidden()"
            >
              <img
                class="mx-auto h-1/2 object-contain"
                :src="require('@/assets/img/click_save.png')"
              />
            </div>
            <div
              class="absolute right-0 bottom-0 cursor-pointer"
              style="width: 40%; height: 12%"
              v-if="img_hidden === false"
            >
              <img
                class="mx-auto h-1/2 object-contain"
                :src="require('@/assets/img/click_icon.png')"
                @click="
                  get_Promo_code();
                  step++;
                  set_step60_50(60);
                "
              />
            </div>

            <div
              class="mt-4 grid grid-cols-2 gap-5 absolute w-full"
              v-if="img_hidden === false"
            >
              <a href="https://www.whatseat.com.tw/" target="_blank">
                <div
                  class="bg-cuswhite rounded-full flex cursor-pointer"
                  style="height: 5.5vh"
                >
                  <img
                    class="m-auto h-5/6"
                    :src="require('@/assets/img/ios.png')"
                  />
                </div>
              </a>
              <a href="https://www.whatseat.com.tw/" target="_blank">
                <div
                  class="bg-cuswhite rounded-full flex cursor-pointer"
                  style="height: 5.5vh"
                >
                  <img
                    class="m-auto h-5/6"
                    :src="require('@/assets/img/android.png')"
                  />
                </div>
              </a>

              <div class="col-span-2 w-full h-11">
                <button
                  class="
                    bg-cusblue
                    text-cuswhite
                    h-full
                    w-full
                    rounded-full
                    text-2xl
                  "
                  @click="share_what_eat()"
                >
                  分享給朋友
                </button>
              </div>
            </div>

            <div
              class="mt-8 grid grid-cols-2 gap-5 absolute w-full"
              v-if="img_hidden === true"
            >
              <div class="col-span-2 w-full cursor-pointer h-50">
                <img
                  class="m-auto h-5/6"
                  :src="require('@/assets/img/logo.png')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--                    8                     -->
      <div
        class="flex h-full w-full mx-auto anim transform"
        :class="step == 61 ? 'opacity-100' : 'opacity-0 '"
        v-if="step >= 60 && step <= 62"
      >
        <div
          class="w-5/6 absolute left-1/2 transform -translate-x-1/2"
          style="height: 60vh; top: 22%"
        >
          <div class="relative">
            <img
              class="mx-auto"
              :src="require('@/assets/img/get_code_icon.png')"
            />
            <p
              class="
                text-white
                absolute
                left-1/2
                transform
                -translate-x-1/3
                bottom-3
              "
              style="width: 40%; height: 12%"
            >
              {{ Promo_code }}
            </p>
            <div
              class="absolute right-12 bottom-5 cursor-pointer"
              style="width: 20%; height: 11%"
              id="copy_text"
              :data-clipboard-text="Promo_code"
              @click="Copy()"
            ></div>
          </div>

          <div class="relative" v-if="step == 61">
            <img
              class="mx-auto h-10 object-contain mt-10"
              :src="require('@/assets/img/close_button.png')"
            />
            <div
              class="
                absolute
                left-1/2
                transform
                -translate-x-1/2
                bottom-0
                cursor-pointer
              "
              style="width: 13%; height: 100%"
              @click="
                step++;
                set_step60_50(50);
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  >
import html2canvas from "html2canvas";
import Clipboard from "clipboard";
import axios from "axios";

export default {
  data() {
    return {
      last_page: false,
      analyze_word: "",
      Promo_code: "00000",
      waht_eat_gif: require("@/assets/img/waht_eat_gif.gif"),
      bg_music: require("@/assets/music/opening.mp3"),
      musiccontrol: false,
      resultImageIcon: require("@/assets/img/kangaroo.png"),
      resultImage: require("@/assets/img/kangaroo2.png"),
      animalType: "",
      step: 0,
      animal: [],
      questionIndex: 0,
      questions: [
        {
          title: "1. 想像一下, 明天就是周末了,你最想約誰來一起吃飯聚會?",
          awns: ["(A) 家人", "(B) 好友", "(C) 另一半", "(D) 工作夥伴"],
        },
        {
          title: "3. 一進入餐廳, 你覺得餐廳整體的色調應該是什麼顏色?",
          awns: [
            "(A) 甜美而夢幻的粉色",
            "(B) 高雅而安靜的銀色",
            "(C) 舒服而清爽的藍色",
            "(D) 明亮而溫暖的橙色",
          ],
        },
        {
          title: "4. 服務生帶你們入座, 你看了看菜單, 你的選擇是?",
          awns: [
            "(A) 滿滿都是肉的燒肉飯",
            "(B) 精緻多樣的壽司拼盤",
            "(C) 多人共享的披薩套餐",
            "(D) 熱騰騰香氣十足的咖哩",
          ],
        },
        {
          title: "5. 在等待餐點的過程中, 你發現隔壁桌在?",
          awns: [
            "(A) 一對家庭正在哄餵不好好吃飯的孩子",
            "(B) 一群學生正在嘻嘻哈哈的聊天",
            "(C) 一對情侶安靜地吃著飯",
            "(D) 隔壁沒有坐人",
          ],
        },
        {
          title: "6. 你的餐點終於來了, 你通常的用餐習慣是?",
          awns: [
            "(A) 吃的過程有一定的順序",
            "(B) 速戰速決",
            "(C) 一口一口慢慢地吃",
            "(D) 挑食, 裡面有不喜歡的配菜絕不吃",
          ],
        },
        {
          title:
            "7. 在一陣愉快的吃飯聊天後, 服務生突然說要招待我們甜點, 你的選擇是?",
          awns: [
            "(A) 水果拼盤",
            "(B) 冰淇淋聖代",
            "(C) 芒果刨冰",
            "(D) 草莓蛋糕",
          ],
        },
      ],
      user_name: "",
      loading: false,
      music_loading: false,
      bgmusic_loading: false,
      step32_loading: false,
      star_loading: false,
      img_hidden: false,
      reloadGif: false,
    };
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      if (!this.star_loading) {
        this.star_loading = true;
        let self = this;
        this.nextStep(1500);
        this.nextStep(2500);
        this.nextStep(3500);
        this.nextStep(5000);
        this.nextStep(6500);
        this.nextStep(7000);
        setTimeout(function () {
          self.star_loading = false;
        }, 7000);
      }
    },
    start_button() {
      if (!this.star_loading) {
        this.star_loading = true;
        let self = this;
        this.nextStep2(500);
        this.set_step(1200, 11);
        this.nextStep(1500);
        setTimeout(function () {
          self.star_loading = false;
        }, 1800);
      }
    },
    awsStep() {
      if (
        this.step == 12 ||
        this.step == 21 ||
        this.step == 23 ||
        this.step == 25 ||
        this.step == 27
      ) {
        let self = this;
        setTimeout(function () {
          self.questionIndex++;
        }, 1800);
      }

      if (this.step == 12) {
        this.reloadGif = true;
        this.waht_eat_gif =
          require("@/assets/img/waht_eat_gif.gif") + "?+" + new Date();
        this.nextStep(1200);
        this.nextStep(2200);
        this.nextStep(3200);
        this.nextStep(4200);
        this.nextStep(5300);
        this.nextStep(12000);
      } else if (this.step == 29) {
        this.nextStep(1200);
        this.nextStep(2200);
        this.nextStep(3200);
      } else {
        this.nextStep(1200);
        this.nextStep(2200);
      }
    },
    nextStep(msec) {
      let self = this;
      setTimeout(function () {
        self.step++;
      }, msec);
    },
    nextStep2(msec) {
      if (!this.loading) {
        this.loading = true;
        let self = this;
        setTimeout(function () {
          self.step++;
        }, msec);
        setTimeout(function () {
          self.loading = false;
        }, msec);
      }
    },
    set_step(msec, step) {
      let self = this;
      setTimeout(function () {
        self.step = step;
      }, msec);
    },
    addArray(Options) {
      this.animal.push(Options);
    },
    choice(Options) {
      if (!this.loading) {
        this.loading = true;
        this.addArray(Options);
        this.awsStep();
        this.animal_analysis();
        let self = this;

        setTimeout(function () {
          self.loading = false;
        }, 2400);
      }
    },
    wait_step18(msec) {
      if (!this.loading) {
        this.loading = true;
        let self = this;
        this.awsStep();
        this.nextStep(msec);

        setTimeout(function () {
          self.reloadGif = false;
          self.loading = false;
        }, msec);
      }
    },
    set_step60_50(step) {
      if (!this.loading) {
        this.loading = true;
        let self = this;
        this.set_step(500, step);
        this.nextStep(1000);
        setTimeout(function () {
          self.loading = false;
        }, 1000);
      }
    },
    getImage() {
      if (this.animalType === "拳擊袋鼠") {
        this.resultImageIcon = require("@/assets/img/kangaroo.png");
        this.resultImage = require("@/assets/img/kangaroo2.png");
      } else if (this.animalType === "鱷魚") {
        this.resultImageIcon = require("@/assets/img/crocodile.png");
        this.resultImage = require("@/assets/img/crocodile2.png");
      } else if (this.animalType === "獅子王") {
        this.resultImageIcon = require("@/assets/img/lion.png");
        this.resultImage = require("@/assets/img/lion2.png");
      } else if (this.animalType === "長毛猴") {
        this.resultImageIcon = require("@/assets/img/monkey.png");
        this.resultImage = require("@/assets/img/monkey2.png");
      } else if (this.animalType === "長頸鹿") {
        this.resultImageIcon = require("@/assets/img/giraffe.png");
        this.resultImage = require("@/assets/img/giraffe2.png");
      } else if (this.animalType === "狐狸") {
        this.resultImageIcon = require("@/assets/img/fox.png");
        this.resultImage = require("@/assets/img/fox2.png");
      } else if (this.animalType === "貓頭鷹") {
        this.resultImageIcon = require("@/assets/img/owl.png");
        this.resultImage = require("@/assets/img/owl2.png");
      } else if (this.animalType === "麋鹿") {
        this.resultImageIcon = require("@/assets/img/deer.png");
        this.resultImage = require("@/assets/img/deer2.png");
      } else if (this.animalType === "刺猬") {
        this.resultImageIcon = require("@/assets/img/Hedgehog.png");
        this.resultImage = require("@/assets/img/Hedgehog2.png");
      } else if (this.animalType === "藍鯨") {
        this.resultImageIcon = require("@/assets/img/whale.png");
        this.resultImage = require("@/assets/img/whale2.png");
      } else if (this.animalType === "甜心熊貓") {
        this.resultImageIcon = require("@/assets/img/panda.png");
        this.resultImage = require("@/assets/img/panda2.png");
      } else if (this.animalType === "大象") {
        this.resultImageIcon = require("@/assets/img/Elephant.png");
        this.resultImage = require("@/assets/img/Elephant2.png");
      }
      console.log(this.resultImageIcon);
      console.log(this.resultImage);
    },
    analyze() {
      /* 第三題 */
      if (/B/.test(this.animal[1]) || /C/.test(this.animal[1])) {
        this.animalType = "獅子王/拳擊袋鼠/長毛猴/狐狸/長頸鹿/鱷魚";
      } else if (/A/.test(this.animal[1]) || /D/.test(this.animal[1])) {
        this.animalType = "貓頭鷹/甜心熊貓/麋鹿/藍鯨/刺猬/大象";
      }

      /* 第四題 */
      if (this.animalType === "獅子王/拳擊袋鼠/長毛猴/狐狸/長頸鹿/鱷魚") {
        if (/A/.test(this.animal[2]) || /B/.test(this.animal[2])) {
          this.animalType = "獅子王/拳擊袋鼠/鱷魚";
        } else if (/C/.test(this.animal[2]) || /D/.test(this.animal[2])) {
          this.animalType = "長毛猴/狐狸/長頸鹿";
        }
      } else if (this.animalType === "貓頭鷹/甜心熊貓/麋鹿/藍鯨/刺猬/大象") {
        if (/A/.test(this.animal[2]) || /B/.test(this.animal[2])) {
          this.animalType = "貓頭鷹/麋鹿/刺猬";
        } else if (/C/.test(this.animal[2]) || /D/.test(this.animal[2])) {
          this.animalType = "甜心熊貓/藍鯨/大象";
        }
      }

      /* 第六題 */
      if (this.animalType === "獅子王/拳擊袋鼠/鱷魚") {
        if (
          /A/.test(this.animal[4]) ||
          /C/.test(this.animal[4]) ||
          /D/.test(this.animal[4])
        ) {
          this.animalType = "拳擊袋鼠/鱷魚";
        } else if (/B/.test(this.animal[4])) {
          this.animalType = "獅子王";
        }
      } else if (this.animalType === "長毛猴/狐狸/長頸鹿") {
        if (
          /A/.test(this.animal[4]) ||
          /C/.test(this.animal[4]) ||
          /D/.test(this.animal[4])
        ) {
          this.animalType = "長毛猴/長頸鹿";
        } else if (/B/.test(this.animal[4])) {
          this.animalType = "狐狸";
        }
      } else if (this.animalType === "貓頭鷹/麋鹿/刺猬") {
        if (/A/.test(this.animal[4])) {
          this.animalType = "貓頭鷹";
        } else if (
          /B/.test(this.animal[4]) ||
          /C/.test(this.animal[4]) ||
          /D/.test(this.animal[4])
        ) {
          this.animalType = "麋鹿/刺猬";
        }
      } else if (this.animalType === "甜心熊貓/藍鯨/大象") {
        if (/C/.test(this.animal[4])) {
          this.animalType = "藍鯨";
        } else if (
          /B/.test(this.animal[4]) ||
          /A/.test(this.animal[4]) ||
          /D/.test(this.animal[4])
        ) {
          this.animalType = "甜心熊貓/大象";
        }
      }

      /* 第七題 */
      if (this.animalType === "拳擊袋鼠/鱷魚") {
        if (/B/.test(this.animal[5]) || /C/.test(this.animal[5])) {
          this.animalType = "拳擊袋鼠";
        } else if (/A/.test(this.animal[5]) || /D/.test(this.animal[5])) {
          this.animalType = "鱷魚";
        }
      } else if (this.animalType === "長毛猴/長頸鹿") {
        if (/B/.test(this.animal[5]) || /C/.test(this.animal[5])) {
          this.animalType = "長毛猴";
        } else if (/A/.test(this.animal[5]) || /D/.test(this.animal[5])) {
          this.animalType = "長頸鹿";
        }
      } else if (this.animalType === "麋鹿/刺猬") {
        if (/B/.test(this.animal[5]) || /C/.test(this.animal[5])) {
          this.animalType = "麋鹿";
        } else if (/A/.test(this.animal[5]) || /D/.test(this.animal[5])) {
          this.animalType = "刺猬";
        }
      } else if (this.animalType === "甜心熊貓/大象") {
        if (/B/.test(this.animal[5]) || /C/.test(this.animal[5])) {
          this.animalType = "甜心熊貓";
        } else if (/A/.test(this.animal[5]) || /D/.test(this.animal[5])) {
          this.animalType = "大象";
        }
      }

      console.log(this.animalType);
    },
    animal_analysis() {
      this.analyze();
      this.getImage();
    },
    reset() {
      if (!this.loading) {
        this.loading = true;
        let self = this;
        this.set_step(1000, 0);
        this.questionIndex = 0;
        this.change_bg_music(require("@/assets/music/opening.mp3"));
        this.animalType = " ";
        this.analyze_word = "";
        this.animal = [];

        this.start();
        setTimeout(function () {
          self.resultImageIcon = "";
          self.resultImage = " ";
          self.loading = false;
        }, 1000);
        setTimeout(function () {
          self.last_page = false;
        }, 3000);
      }
    },
    close() {
      var audio = document.getElementById("music1");
      if (audio.paused) {
        audio.play(); // 播放
        this.musiccontrol = true;
      } else {
        audio.pause(); // 暂停
        this.musiccontrol = false;
      }
    },
    start_music(obj, msec) {
      if (!this.music_loading) {
        this.music_loading = true;
        let self = this;
        var audio = document.getElementById(obj);
        if (this.musiccontrol) {
          audio.play();
        }

        setTimeout(function () {
          self.music_loading = false;
        }, msec);
      }
    },
    change_bg_music(mp3) {
      if (!this.bgmusic_loading) {
        this.bgmusic_loading = true;
        let self = this;
        this.bg_music = mp3;
        self.$refs.music1.load();
        if (this.musiccontrol == true) {
          setTimeout(function () {
            var playPromise = music1.play();
            if (playPromise !== undefined) {
              playPromise.then((_) => {
                self.$refs.music1.play();
              });
            }
          }, 2500);
        }
        setTimeout(function () {
          self.bgmusic_loading = false;
        }, 2500);
      }
    },
    change_word() {
      let self = this;
      if (!this.step32_loading) {
        self.step32_loading = true;

        self.nextStep(800);
        self.set_step(1300, 39);
        self.nextStep(1500);
        self.change_bg_music(require("@/assets/music/siri.mp3"));
        self.start_music("music4", 2500);
        setTimeout(function () {
          self.analyze_word = "分析中<br>請稍候";
        }, 2500);
        setTimeout(function () {
          self.analyze_word = "分析中<br>請稍候.";
        }, 5000);
        setTimeout(function () {
          self.analyze_word = "分析中<br>請稍候..";
        }, 7500);
        setTimeout(function () {
          self.analyze_word = "分析中<br>請稍候...";
        }, 10000);
        setTimeout(function () {
          self.analyze_word = "分析結束";
        }, 12500);
        self.nextStep(13000);
        setTimeout(function () {
          self.step32_loading = false;
        }, 13000);
      }
    },
    run_love_41() {
      if (!this.star_loading) {
        this.star_loading = true;
        let self = this;
        this.awsStep();
        this.nextStep(2500);
        this.nextStep(3000);
        this.nextStep(3400);
        this.nextStep(3700);
        this.set_step(4100, 50);
        this.nextStep(4500);

        setTimeout(function () {
          self.star_loading = false;
        }, 4000);
      }
    },
    getImg() {
      html2canvas(document.getElementById("pic"), {
        backgroundColor: null, //画出来的图片有白色的边框,设置背景为透明色（null）
        useCORS: true, //支持图片跨域
        scale: 2, //设置放大的倍数
      }).then((canvas) => {
        //如果你需要下载截图，可以使用a标签进行下载
        let a = document.createElement("a");
        a.href = canvas.toDataURL("image/jpg");
        a.download = "whatsEat";
        a.click();
      });
    },
    getImg_hidden() {
      let self = this;
      self.img_hidden = true;
      setTimeout(function () {
        self.getImg();
      }, 500);

      setTimeout(function () {
        self.img_hidden = false;
      }, 800);
    },
    get_name() {
      this.user_name = this.$refs.getValue.value;
      console.log(this.user_name);
    },
    Copy() {
      let clipboard = new Clipboard("#copy_text");
      clipboard.on("success", (e) => {
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        console.log(e);
        clipboard.destroy();
      });
    },
    get_Promo_code() {
      const apiURL =
        "https://0o4whnqb7d.execute-api.ap-southeast-1.amazonaws.com/dev/animal/createCode"; // origin api url
      axios
        .post(`${apiURL}`, { type: this.animalType })
        .then((res) => {
          console.log(res);
          this.Promo_code = res.data.num;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    share_what_eat() {
      if (this.user_name === "") {
        this.user_name = "我";
      }
      if (navigator.share) {
        navigator
          .share({
            title: "Web Fundamentals",
            text:
              this.user_name +
              " 是一隻 " +
              this.animalType +
              " ! \n從你愛的美食看性格, 看看我們合不合!!",
            url: "https://whatseat-a4b2a.web.app/",
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      } else {
        alert("Browser doesn't support Web Share API");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.anim {
  transition: all 0.8s ease;
}
</style> 
